import TransportingOrderForwardDeleteRequest from "../../../../../api/raily/order/transporting-order/forwarding/delete/order-transporting-order-forwarding-delete.request";
import OrderTransportingOrderForwardingDeleteParams from "./order-transporting-order-forwarding-delete-params";

const create = (
  params: OrderTransportingOrderForwardingDeleteParams,
): TransportingOrderForwardDeleteRequest => {
  return {
    orderId: params.orderUuid,
    forwardActionId: params.forwardingUuid,
  };
};

const orderTransportingOrderForwardingDeleteParamsFactory = {
  create,
};

export default orderTransportingOrderForwardingDeleteParamsFactory;
